import { PaginationPayload } from 'app/shared/pagination/models';

const BASE = ['orgs'] as const;

export const ORG_MANAGEMENT_QUERY_KEYS = {
  getOrgs: () => [...BASE, 'orgs'] as const,
  getOrg: (id: number) => [...BASE, 'org', id] as const,
  getWatchlistScreeningStats: (id: number) =>
    [...BASE, 'watchlist-screening-stats', id] as const,
  getDefaultRules: () => [...BASE, 'default-rules'] as const,
  getOrgSettings: (id: number) => [...BASE, 'org-settings', id] as const,
  getOrgChildren: (orgId: number) =>
    [...BASE, 'getOrgChildren', orgId] as const,
  getOrgAgents: (orgID: number) => [...BASE, 'org-agents', orgID] as const,
  getOrgParentAgents: (orgId: number, payload?: PaginationPayload) => {
    if (payload) {
      return [...BASE, 'org-parent-agents', orgId, payload] as const;
    }
    return [...BASE, 'org-parent-agents', orgId] as const;
  },
  listFingerprintKeys: (orgId: number) =>
    [...BASE, 'fingerprint-keys', orgId] as const,
  listTrmKeys: (orgId: number) => [...BASE, 'trm-keys', orgId] as const,
};
